module.exports = __webpack_public_path__ + "img/how-long-til-black-future-month.0ab295f2.png";